import { Component, registerComponent } from "aframe";

registerComponent("render-order", {
	schema : { type : "number" },
	update(this : Component & { data : number } )
	{
		this.el.object3D.renderOrder = this.data;
	}
})